module.exports = __webpack_public_path__ + "img/circular.db84357c.svg";